













import { Component, Prop, Vue } from 'vue-property-decorator'

import { mdiChevronRight } from '@mdi/js'

import { BreadcrumbsItem } from '@/components/lib/Breadcrumbs/types'

@Component
class Breadcrumbs extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  readonly items!: Array<BreadcrumbsItem>

  icons = {
    mdiChevronRight,
  }
}

export default Breadcrumbs
